import React, { useState } from 'react';
import { Image, View, ImageBackground, StyleSheet, Platform } from 'react-native'
import { connect } from 'react-redux'
import { Button, Icon, Input } from 'react-native-elements'
import background from '../../images/background-slot.jpg'
import logo from '../../images/main-logo.png'
import * as Facebook from 'expo-facebook';
import FacebookLoginWeb from 'react-facebook-login/dist/facebook-login-render-props';
import { fbLogin, spzLogin, loading } from '../../redux/actions'
import { REACT_APP_FACEBOOK_APP_ID } from 'react-native-dotenv'
import TextZ from '../TextZ';

const INSECURE = (!!window.location.href.match(/^http\:\/\/localhost/)) ? 'NONE1234567890' : '';
const NO_FACEBOOK = true

const LoginForm = ({ onLogin: doLogin }) => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const onLogin = (u, p) => {
    if (loading ) {
      return;
    }
    if (!u || !p) {
      alert("กรอกยูสเซอร์ หรือรหัสผ่านให้เรียบร้อย")
      return
    }

    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 5000)
    doLogin && doLogin(username, password)
  }

  return <View style={styles.form}>
    <TextZ style={{ color: '#ffffff'}}>เข้าสู่ระบบ</TextZ>

    <Input
      placeholder="ยูสเซอร์"
      leftIcon={{ type: 'font-awesome', name: 'user', color: '#ffffff' }}
      value={username}
      inputStyle={styles.input}
      onChangeText={value => setUsername(value)}
    />
    <Input
      placeholder="รหัสผ่าน"
      leftIcon={{ type: 'font-awesome', name: 'lock', color: '#ffffff' }}
      value={password}
      type="password"
      inputStyle={styles.input}
      onChangeText={value => setPassword(value)}
    />
    <Button title="เข้าสู่ระบบ" onPress={() => onLogin(username, password)} loading={loading} ></Button>

    <TextZ style={{ color: 'red', marginTop: 40 }}>* สมาชิกจากเว็บ VIP ให้ขอรหัสได้ที่เว็บที่ท่านเล่น</TextZ>
  </View>
}

class Component extends React.Component {

  componentDidMount() {
    if (INSECURE) {
      this.login({
        name: "test",
        userID: '123',
        accessToken: INSECURE,
      })

      return
    }

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const authtoken = params.get('auth')

    // console.log('authtoken', authtoken)
    if (authtoken) {
      this.props.spzLogin(authtoken)
    }
  }
    
  logInApp = async ($this) => {
        try {
          this.props.loading(true)
          const {
            type,
            token,
          } = await Facebook.logInWithReadPermissionsAsync({
            permissions: ['public_profile'],
          });

          if (type === 'success') {
            // Get the user's name using Facebook's Graph API
            const response = await fetch(`https://graph.facebook.com/me?access_token=${token}`);
            const data = await response.json()
            this.login(data, $this)
          } else {
            // type === 'cancel'
            
          }
        } catch ({ message }) {
          
          alert(`Facebook Login Error: ${message}`);
        }
        this.props.loading(false)
    }

    login = async ({ name, userID, accessToken }) => {
      this.props.fbLogin({name, userID, accessToken})
    }

    
    button() {
      if  (NO_FACEBOOK) {
        return null;
      }
      if  (INSECURE) {
        return null;
      }
      // https://www.facebook.com/v2.3/dialog/oauth?app_id=984124205291463&cbt=1596021901875&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3fd826472d6394%26domain%3Dslot.ufaprimo.com%26origin%3Dhttps%253A%252F%252Fslot.ufaprimo.com%252Ff3601966c7453b%26relation%3Dopener&client_id=984124205291463&display=popup&domain=slot.ufaprimo.com&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fslot.ufaprimo.com%2F&locale=en_US&logger_id=f822f5d00b49c4&origin=1&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df1fa30a834e4e34%26domain%3Dslot.ufaprimo.com%26origin%3Dhttps%253A%252F%252Fslot.ufaprimo.com%252Ff3601966c7453b%26relation%3Dopener%26frame%3Df1626d7484c96a8&response_type=token%2Csigned_request%2Cgraph_domain&sdk=joey&version=v2.3&_rdc=1&_rdr
      if (Platform.OS == 'web') {
        return <FacebookLoginWeb
          appId={REACT_APP_FACEBOOK_APP_ID}
          autoLoad={true}
          fields="name,email,picture"
          callback={(d) => this.login(d)}
          cssClass=""
          icon="fa-facebook"
          redirectUri={`${window.location.protocol}//${window.location.host}/`}
          render={renderProps => (
            <Button 
              titleStyle={{
                  fontSize: 20
              }} 
              buttonStyle={{
                  paddingHorizontal: 30,
              }}
              title={` เข้าสู่ระบบ`}
              icon={<Icon name="facebook" type="font-awesome" size={20} color='white' />}
              onPress={renderProps.onClick}
            />
          )}
        />
      }

      return <Button 
        titleStyle={{
            fontSize: 20
        }} 
        buttonStyle={{
            paddingHorizontal: 30,
        }}
        title=" เข้าสู่ระบบ"
        icon={<Icon name="facebook" type="font-awesome" size={20} color='white' />}
        onPress={() => { this.logInApp(this) }}
      />
    }

    render() {
        return <ImageBackground source={background} style={styles.container}>
  
            <View style={{
                flexDirection: 'column',
                alignItems: 'center',
                alignContent: 'center',
                flexGrow: 1,
                
            }}>
              <Image source={logo} style={{width: 160, height: 160, margin: 20}}/>
              {this.button()}
              <LoginForm onLogin={(u,p) => {
                this.props.spzLogin('', u, p)
              }} />
            </View>
        </ImageBackground>
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
    },
    form: {
      padding: 16,
      backgroundColor: 'rgba(0,0,0,0.7)'
    },
    input: {
      color: '#ffffff',
      paddingLeft: 15,
      marginLeft: 15,
    },
});
  


const mapStateToProps = state => {
  return {
      auth: state.auth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loading: x => dispatch(loading(x)),
    fbLogin: (data) => dispatch(fbLogin(data)),
    spzLogin: (t, u, p) => dispatch(spzLogin(t, u, p)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);

